<template>
  <div class="app-wrapper">
    <div class="updater_area">
      <div class="start_image_wrapper">
        <div v-if="isUpdateDialog" class="updated-card">
          <div class="updated-card-title">版本更新公告</div>
          <div class="updated-card-info">
            <div style="margin: 10px 10px 10px 20px;overflow-y: scroll;height: 8rem;white-space: break-spaces">
              <span style="font-size: 1rem;margin-bottom: 10px">检测到新版本 v{{currentVersion}} -> v{{updateVersion}}</span><br/>
              <br/>
              <pre style="white-space: pre-wrap">{{content}}</pre>
            </div>
          </div>
          <div style="display:flex;align-items: center;justify-content: center;margin-top: .6rem;">
            <el-button style="width: 5rem;font-size: 0.6rem;height: 1.5rem;line-height: 1.5rem;padding: 0;" type="primary" @click="updateNow">立即更新</el-button>
          </div>
          <div v-if="!canSkip" class="updated-card-not-skip-text">*重要版本更新无法跳过</div>
          <div v-else class="updated-card-skip">
            <div @click="skipUpdate">跳过</div>
          </div>
        </div>
      </div>
      <div class="progress_container">
        <p class="progress_text">{{ progressText }} <span v-if="isUpdate">{{ barWidth }}</span></p>
        <div class="progress progress-striped">
          <div class="progress-bar"
               :style="{width: barWidth, transitionDuration: transitionDuration}"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {recordClientUseVersion} from "../api/common";
import config from '../../package.json'
export default {
  name: "update",
  data() {
    return {
      downloadPercent: 0,
      barWidth: '0%',
      transitionDuration: null,
      progressText: '检查更新...',
      isUpdate: false,
      isUpdateDialog: false,
      canSkip: false,
      currentVersion: config.version,
      updateVersion: '',
      content: ""
    }
  },
  created() {
    const isDevelopment = process.env.NODE_ENV !== 'production'
    if(isDevelopment || !this.$isElectron()){
      this.startDefaultLoading()
    }else{
      this.startAutoUpdater()
    }
    recordClientUseVersion({clientVersion:config.version })
  },
  methods: {
    startDefaultLoading: function () {
      this.progressText = '加载中, 请稍候...'
      this.barWidth = Math.floor((Math.random() * 65) + 10) + '%'
      setTimeout(() => {
        const randomSeconds = Math.floor((Math.random() * 2) + 2)
        this.transitionDuration = randomSeconds + 's'
        this.barWidth = '100%'
        setTimeout(() => {
          this.finishUpdate()
        }, randomSeconds * 1000)
      }, 500)
    },
    finishUpdate: function () {
      this.progressText = '加载完成'
      this.$router.push({name: 'login'})
    },
    startAutoUpdater: function () {
      const that = this
      const {ipcRenderer} = require("electron");
      ipcRenderer.send('checkForUpdate')
      ipcRenderer.on('message', (event, data) => {
        console.log(event,'event')
        console.log(data, 'data')
        if (data.status === 2) {// 您现在使用的版本为最新版本,无需更新!
          // 做一个假的进度条
          this.startDefaultLoading()
        } else if (data.status === 1) { // 检测到新版本
          this.isUpdateDialog = true
          this.progressText = data.msg
        }else if(data.status === -1) { // 检测更新异常
          this.progressText = data.msg
        }
      })
      // 有可用更新包
      ipcRenderer.on("update-available",(e,info) => {
        // 获取当前版本信息
        if(that.compareVersions(that.currentVersion, info.lastForceUpdateVersion) === -1) {
          that.canSkip = false
        }else{
          that.canSkip = !info.currentForceUpdate
        }
        that.content = info.content
        that.updateVersion = info.version
        console.log("info--->",info)
      })
      // 注意：“downloadProgress”事件可能存在无法触发的问题，只需要限制一下下载网速就好了
      ipcRenderer.on('downloadProgress', (event, progressObj) => {
        console.log(progressObj)
        this.progressText = '检测到新版本,正在下载'
        this.downloadPercent = progressObj.percent || 0
        if (progressObj.percent) {
          this.barWidth = Math.round(progressObj.percent) + '%'
        } else {
          this.barWidth = '0%'
        }
        if(progressObj.percent === 100){
          this.progressText = '更新完成'
        }
      })
      // ipcRenderer.on('isUpdateNow', () => {
      //   ipcRenderer.send('isUpdateNow')
      // })
      ipcRenderer.on('updateError', (event, err) => {
        // 做一个假的进度条
        this.startDefaultLoading()
      })
    },
    updateNow() {
      this.isUpdateDialog = false
      this.isUpdate = true
      const {ipcRenderer} = require("electron");
      ipcRenderer.send('downloadUpdate')
    },
    skipUpdate() {
      this.isUpdateDialog = false
      this.startDefaultLoading()
    },
    compareVersions(version1, version2) {
      // 将版本号拆分成数字数组
      var arr1 = version1.split('.');
      var arr2 = version2.split('.');

      // 遍历数字数组进行逐段比较
      for (var i = 0; i < Math.max(arr1.length, arr2.length); i++) {
        var num1 = parseInt(arr1[i] || 0); // 如果数组长度不够，则将缺失部分补0
        var num2 = parseInt(arr2[i] || 0);

        if (num1 < num2) {
          return -1; // 版本1小于版本2
        } else if (num1 > num2) {
          return 1; // 版本1大于版本2
        }
      }

      return 0; // 版本1等于版本2
    }
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(~@/assets/img/mainBg.png) no-repeat;
  // background-color: red;
  background-size: 100% 100%;
  .updater_area {
    .start_image_wrapper {
    //  /*比例 909x968*/
      width: 27rem;
      height: 27rem;
      margin: 0 auto 5px;
      padding: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      .updated-card{
        width: 28rem;
        height: 18rem;
        background: rgba(13, 66, 100, 0.62);
        border-radius: 20px;
        background-image: url(~@/assets/img/update-card.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .updated-card-title{
          font-size: 1rem;
          font-weight: bold;
          color: #00FFFE;
          margin-top: 2.6rem;
          text-align: center;
        }
        .updated-card-body{
          font-size: 1rem;
          font-weight: bold;
          color: #000000;
          margin-top: 4rem;
          text-align: center;
        }
        .updated-card-info{
          font-size: .7rem;
          margin-top: 1rem;
          text-align: left;
          width: 22rem;
          height: 9rem;
          margin-left: calc((100% - 23rem)/2);
          background-color: #12527C;
          color: white;
          padding-top: 10px;
          border-radius: 8px;
        }
        .updated-card-not-skip-text{
          font-size: 0.6rem;
          font-weight: bold;
          color: #FF2222;
          text-align: center;
          margin-top: .2rem;
        }
        .updated-card-skip{
          font-size: 0.6rem;
          font-weight: bold;
          color: #3D5E6B;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: .2rem;
          div{
            cursor: pointer;
          }
        }
      }
    }
    .progress_container {
      width: 80vw;
      margin: 0 auto;
      .progress {
        padding: 4px;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 5px;
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25), 0 1px rgba(255, 255, 255, 0.08);
        .progress-bar {
          height: 2rem;
          background-color: #ee303c;
          border-radius: 4px;
          transition: 0.4s linear;
          transition-property: width, background-color;
        }
      }
      .progress-striped .progress-bar {
        width: 100%;
        background:#00E5FF linear-gradient(
                45deg, rgba(0, 229, 255, 1) 25%,
                transparent 25%, transparent 50%,
                rgba(0, 229, 255, 1) 50%,
                rgba(0, 229, 255, 1) 75%,
                transparent 75%, transparent);

        animation: progressAnimationStrike 6s;
      }
      .progress_text {
        margin-bottom: 1rem;
        text-align: center;
        color: #00E5FF;
        font-size: 1.2rem;
      }
    }
  }
}
</style>
